export class PointerDragAndDrop {
    constructor({
        draggableElement = 'tr'
    } = {}) {
        this.draggableElement = draggableElement;
        this.currentDragElement = null;
        this.dragClone = null;
        this.grabOffsetX = 0;
        this.grabOffsetY = 0;
    }

    pointerDown(event) {
        if (event.target.closest('input, select, textarea, button, a, label')) {
            return;
        }

        this.currentDragElement = event.target.closest(this.draggableElement);
        this.currentDragElement.setPointerCapture(event.pointerId);

        const draggedRowRect = this.currentDragElement.getBoundingClientRect();

        this.grabOffsetX = event.clientX - draggedRowRect.left;
        this.grabOffsetY = event.clientY - draggedRowRect.top;

        this.dragClone = this.currentDragElement.cloneNode(true);
        this.dragClone.setAttribute('x-ignore', '');
        this.dragClone.style.position = 'fixed';
        this.dragClone.style.width = `${draggedRowRect.width}px`;
        this.dragClone.style.left = `${draggedRowRect.left}px`;
        this.dragClone.style.top = `${draggedRowRect.top}px`;
        this.dragClone.style.pointerEvents = 'none';
        this.dragClone.style.opacity = '0.85';
        this.dragClone.style.zIndex = '9999';

        document.body.appendChild(this.dragClone);
        this.currentDragElement.style.opacity = '0';

        document.body.style.userSelect = 'none';
        document.body.style.webkitUserSelect = 'none';
    }

    pointerMove(event) {
        if (!this.currentDragElement) {
            return;
        }

        this.dragClone.style.left = `${event.clientX - this.grabOffsetX}px`;
        this.dragClone.style.top = `${event.clientY - this.grabOffsetY}px`;

        const hoveredElement = document
            .elementFromPoint(event.clientX, event.clientY)
            ?.closest(this.draggableElement);

        const draggedGroup = this.currentDragElement.dataset.dragGroup;
        const hoveredGroup = hoveredElement?.dataset.dragGroup;

        if (!hoveredElement || draggedGroup !== hoveredGroup) {
            this.dragClone.style.visibility = 'hidden';
            document.body.style.cursor = 'not-allowed';

            return;
        }

        this.dragClone.style.visibility = '';
        document.body.style.cursor = '';

        if (hoveredElement === this.currentDragElement) {
            return;
        }

        const parent = hoveredElement.parentNode;
        const siblings = Array.from(parent.children);
        const currentDragElementIndex = siblings.indexOf(this.currentDragElement);
        const hoveredElementIndex = siblings.indexOf(hoveredElement);

        if (currentDragElementIndex < hoveredElementIndex) {
            parent.insertBefore(this.currentDragElement, hoveredElement.nextSibling);

            return;
        }

        parent.insertBefore(this.currentDragElement, hoveredElement);
    }

    pointerUp({ onDropFinished = (ids) => {} }) {
        if (!this.currentDragElement) {
            return;
        }

        this.dragClone.remove();
        this.dragClone = null;
        this.currentDragElement.style.opacity = '1';
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
        document.body.style.webkitUserSelect = '';

        const ids = Array.from(this.$root.querySelectorAll('[drag-item]'))
            .map((item) => item.getAttribute('drag-item'));

        this.currentDragElement = null;

        onDropFinished(ids);
    }
}

export default function pointerDragAndDrop(options = {}) {
    return new PointerDragAndDrop(options);
}
